export default __webpack_public_path__ + "static/media/streamer_avatar17.84f80106.png";